"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function updateModulesStudied({ modulesStudied, courseId }, sessionEvent) {
    const { modules } = sessionEvent;
    return (modulesStudied +
        modules.filter(module => module.courseId === courseId).length);
}
exports.default = updateModulesStudied;
